export const normalizeNumber = (value: string | number): number => {
    if (value === null || value === undefined) {
        return 0;
    }
    const str = `${value}`.trim();
    const normalized = str.replace(',', '.');
    const cleaned = normalized.endsWith('.') ? normalized.slice(0, -1) : normalized;
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
};

export const roundNumber = (value: number): number => Math.round(value * 100) / 100;
